import { Role, RolesListResponse, PermissionItem, UserPermissions } from '../types';
import apiClient from './apiClient';

export interface CreateRoleData {
  name: string;
  display_name?: string;
  description?: string;
  permissions?: UserPermissions;
}

export interface UpdateRoleData {
  display_name?: string;
  description?: string;
  permissions?: UserPermissions;
  is_active?: boolean;
}

/**
 * Roles API service
 */
export const rolesApi = {
  /**
   * Get all roles
   */
  getRoles: async (): Promise<RolesListResponse> => {
    return apiClient.get<RolesListResponse>('/roles');
  },

  /**
   * Get role by ID
   */
  getRole: async (roleId: number): Promise<{ role: Role }> => {
    return apiClient.get<{ role: Role }>(`/roles/${roleId}`);
  },

  /**
   * Create a new role
   */
  createRole: async (data: CreateRoleData): Promise<{ message: string; role: Role }> => {
    return apiClient.post<{ message: string; role: Role }>('/roles', data);
  },

  /**
   * Update role
   */
  updateRole: async (roleId: number, data: UpdateRoleData): Promise<{ message: string; role: Role }> => {
    return apiClient.put<{ message: string; role: Role }>(`/roles/${roleId}`, data);
  },

  /**
   * Delete role (soft delete)
   */
  deleteRole: async (roleId: number): Promise<{ message: string }> => {
    return apiClient.delete<{ message: string }>(`/roles/${roleId}`);
  },

  /**
   * Get available permissions
   */
  getPermissions: async (): Promise<{ permissions: PermissionItem[] }> => {
    return apiClient.get<{ permissions: PermissionItem[] }>('/roles/permissions');
  },
};

export default rolesApi;
